"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('underscore'),
  keys = _require.keys,
  omit = _require.omit;
var TRANSLATABLE_FIELDS = ['title', 'url', 'text', 'requirements'];
var LEGAL_DOC_FIELDS = {
  title: {
    order: 1,
    translated: true
  },
  url: {
    order: 2,
    label: 'Link',
    tooltip: 'Link to the legal document (an HTTPS resource is required), alternatively provide a text below',
    translated: true
  },
  text: {
    order: 3,
    kind: 'html',
    translated: true
  },
  requirements: {
    order: 4,
    kind: 'list',
    kind_options: {
      item_kind: 'nested-object',
      item_kind_name: '{{label}}',
      fields: {
        label: {
          order: 1,
          tooltip: 'Use {{link}} to insert a link to the document',
          kind: 'text',
          translated: true
        }
      }
    },
    default: [{
      label: 'I acknowledge that I have read and agree to {{link}}. I understand that I can withdraw my consent for processing of my personal data at any time.'
    }, {
      label: 'I consent to the processing of my personal data for the purposes described in {{link}}.'
    }]
  }
};
var LegalDocEditor = /*#__PURE__*/function () {
  LegalDocEditor.$inject = ["$q", "EventEmitter", "metadataService", "modalService", "legalDocumentsService"];
  /* @ngInject */
  function LegalDocEditor($q, EventEmitter, metadataService, modalService, legalDocumentsService) {
    _classCallCheck(this, LegalDocEditor);
    this.$q = $q;
    this.EventEmitter = EventEmitter;
    this.metadataService = metadataService;
    this.modalService = modalService;
    this.legalDocsService = legalDocumentsService;
    this.templateIndex = {};
    this.docLanguages = [];
    this.docTranslations = {};
    this.docFields = LEGAL_DOC_FIELDS;
  }
  _createClass(LegalDocEditor, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.initDocTranslations();
      this.legalDocsService.getAllDocumentTemplates().then(function (templates) {
        return _this.templates = templates;
      });
      if (this.modalRegisterSerialize) {
        this.modalRegisterSerialize(this.EventEmitter({
          serialize: function serialize() {
            return _this.serialize();
          }
        }));
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.model && this.model) {
        this.model = angular.copy(this.model);
        if (this.model.template) {
          this.onTemplateChange(this.model.template);
        } else {
          this.initDocTranslations();
        }
      }
    }
  }, {
    key: "initDocTranslations",
    value: function initDocTranslations() {
      this.docTranslations = this.splitTranslations(this.model);
      this.docLanguages = keys(this.docTranslations);
      if (this.docLanguages.length === 0) {
        this.addLanguage('en');
      } else {
        this.currentLang = this.docLanguages[0];
      }
    }

    // Templates
  }, {
    key: "onTemplateChange",
    value: function onTemplateChange(id) {
      var _this2 = this;
      if (!id) {
        return this.initDocTranslations();
      }
      if (this.loadingTemplate) return;
      this.loadingTemplate = true;
      this.legalDocsService.getDocumentTemplate(id).then(function (template) {
        _this2.templateIndex[id] = template;
        if (!_this2.model.template_fields) {
          console.log('extractDefaults');
          _this2.model.template_fields = _this2.metadataService.extractDefaults(template.template_fields_metadata);
        }
      }).finally(function () {
        return _this2.loadingTemplate = false;
      });
    }
  }, {
    key: "template",
    value: function template() {
      var templateId = this.model.template;
      return templateId ? this.templateIndex[templateId] : null;
    }

    // Translations
  }, {
    key: "showNewLanguagePrompt",
    value: function showNewLanguagePrompt() {
      var _this3 = this;
      this.modalService.openModalWithComponent({
        title: 'Add a new language',
        component: 'bs-language-picker',
        saveLabel: 'Add'
      }).then(function (code) {
        return _this3.addLanguage(code);
      });
    }
  }, {
    key: "addLanguage",
    value: function addLanguage(code) {
      if (!code) return;
      if (this.docTranslations[code]) {
        return this.currentLang = code;
      }
      this.docTranslations[code] = this.metadataService.extractDefaults(LEGAL_DOC_FIELDS);
      this.docLanguages.push(code);
      this.currentLang = code;
    }

    // {title: {en: 'x', hr: 'y'}} => {en: {title: 'x'}, hr: {title:'y'}}
  }, {
    key: "splitTranslations",
    value: function splitTranslations(doc) {
      var translations = {};
      TRANSLATABLE_FIELDS.forEach(function (fieldName) {
        var field = doc[fieldName];
        if (!field) return;
        keys(field).forEach(function (lang) {
          if (!translations[lang]) {
            translations[lang] = {};
          }
          translations[lang][fieldName] = field[lang];
        });
      });
      return translations;
    }

    // {en: {title: 'x'}, hr: {title:'y'}} => {title: {en: 'x', hr: 'y'}}
  }, {
    key: "combineTranslations",
    value: function combineTranslations(translations) {
      var combined = {};
      keys(translations).forEach(function (lang) {
        var translatedFields = translations[lang];
        keys(translatedFields).forEach(function (fieldName) {
          if (!combined[fieldName]) combined[fieldName] = {};
          combined[fieldName][lang] = translatedFields[fieldName];
        });
      });
      return combined;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      if (this.model.template) {
        if (!this.model.use_ackd || !this.model.template_title) {
          return this.$q.reject('You need to accept terms and conditions');
        }
        return omit.apply(void 0, [this.model].concat(TRANSLATABLE_FIELDS));
      }
      var newDoc = angular.extend({}, this.model, this.combineTranslations(this.docTranslations));
      if (!newDoc.title || !newDoc.title.en) {
        return this.$q.reject('Missing title');
      }
      if (newDoc.template === '') {
        delete newDoc.template;
      }
      return newDoc;
    }
  }]);
  return LegalDocEditor;
}();
module.exports = angular.module('backstage.components.legal-docs.editor', ['backstage.services']).component('bsLegalDocEditor', {
  templateUrl: '/src/angular/components/legal-documents/legal-doc-editor/legal-doc-editor.html',
  bindings: {
    model: '<',
    modalRegisterSerialize: '&'
  },
  controller: LegalDocEditor
}).name;